export var PublicEvents;
(function (PublicEvents) {
    PublicEvents["SCREEN"] = "screen";
    PublicEvents["DYNAMIC_LINK"] = "dynamic_links";
    PublicEvents["FORM_FIELD"] = "form_field";
    PublicEvents["AD_IMPRESSION"] = "ad_impressions";
    PublicEvents["SCROLL"] = "scroll";
    PublicEvents["HOVER"] = "hover";
    PublicEvents["DOCUMENT_LINK"] = "document_links";
    PublicEvents["EXIT_LINK"] = "exit_links";
    PublicEvents["TAB"] = "tab";
    PublicEvents["INTERNAL_VIDEO"] = "internal_video";
    PublicEvents["EXTERNAL_VIDEO"] = "external_video";
    PublicEvents["PERSONALIZATION_IMPRESSION"] = "personalization_impression";
    PublicEvents["PERSONALIZATION_INTERACTION"] = "personalization_interaction";
    PublicEvents["PERSONALIZATION_CLICK"] = "personalization_click";
    PublicEvents["MODAL"] = "modal";
    PublicEvents["AD_CLICK"] = "ad_clicks";
})(PublicEvents || (PublicEvents = {}));
